import { useUserReport } from '../../ReportingGroup/context/UserReportContext'
import { useCourseReport } from '../../ReportingGroup/context/CourseReportContext'
import { formatTgblDatePicker, getTgblFieldsDatePicker } from '../../ReportingGroup/utils'
import { useState } from 'react'

const DateRange = ({ ...props }) => {

  const { datePicker, setDatePicker, teamData } = props.from === 'Course Report' ? useCourseReport() : props.from === 'User Report' ? useUserReport() : {}

  const [ dateRange, setDateRange ] = useState( datePicker || JSON.stringify({
    start: formatTgblDatePicker( teamData.team_created_on ),
    end: new Date().toISOString().slice(0, 10)
  }))

  const datePickerName = props.allowedFrom.includes( props.from ) ? `msync_group_reports_date_picker_${props.from.toLowerCase().replace(/ /g,"_")}` : ''

  const renderDatePicker = props.allowedFrom.includes( props.from ) && tangibleFields.render({
    type: 'date-picker',
    dateRange: true,
    multiMonth: 2,
    datePresets: true,
    name: datePickerName,
    value: dateRange,
    onChange: newValue => {
      if( newValue === '' ) return 
      setDatePicker( newValue )
      props?.setDateValue( getTgblFieldsDatePicker( newValue ) )
    }
  })
  
  return renderDatePicker
}

export default DateRange
